import React from "react";
import {
  PRIORITY_STYLES,
  STATUS_STYLES,
} from "./DailyActivityLoggerConstants";
import TaskModalShell from "./TaskModalShell";
import {
  MODAL_FIELD,
  MODAL_LABEL,
  MODAL_READONLY,
  MODAL_NOTES_VIEW,
  MODAL_ROW_2,
  ModalFooterButton,
  ProgressInline,
} from "./taskModalUi";

function TaskViewModal({ open, task, context = "today", onClose }) {
  if (!task) return null;

  const isFuturePlan = context === "future";
  const progress = Number(task.progress_percent ?? 0);
  const hasNotes = Boolean(task.outcome?.trim());

  return (
    <TaskModalShell
      open={open}
      onClose={onClose}
      size="xl"
      eyebrow="View task"
      title="View Task"
      subtitle="Read-only task details"
      footer={
        <ModalFooterButton primary onClick={onClose}>
          Close
        </ModalFooterButton>
      }
    >
      <div className="flex flex-col gap-4">
        <div className={MODAL_FIELD}>
          <span className={MODAL_LABEL}>Task Title</span>
          <div className={MODAL_READONLY}>
            {task.description || "—"}
          </div>
        </div>

        {isFuturePlan ? (
          <div className={MODAL_FIELD}>
            <span className={MODAL_LABEL}>Priority</span>
            <div className={MODAL_READONLY}>
              {task.priority ? (
                <span
                  className={`inline-flex rounded-md px-2 py-0.5 text-xs font-semibold ${
                    PRIORITY_STYLES[task.priority] || ""
                  }`}
                >
                  {task.priority}
                </span>
              ) : (
                "—"
              )}
            </div>
          </div>
        ) : (
          <div className={MODAL_ROW_2}>
            <div className={MODAL_FIELD}>
              <span className={MODAL_LABEL}>Priority</span>
              <div className={MODAL_READONLY}>
                {task.priority ? (
                  <span
                    className={`inline-flex rounded-md px-2 py-0.5 text-xs font-semibold ${
                      PRIORITY_STYLES[task.priority] || ""
                    }`}
                  >
                    {task.priority}
                  </span>
                ) : (
                  "—"
                )}
              </div>
            </div>

            <div className={MODAL_FIELD}>
              <span className={MODAL_LABEL}>Status</span>
              <div className={MODAL_READONLY}>
                <span
                  className={`inline-flex rounded-md px-2 py-0.5 text-xs font-semibold ${
                    STATUS_STYLES[task.status] ||
                    "border border-gray-200 bg-white text-gray-500"
                  }`}
                >
                  {task.status || "Pending"}
                </span>
              </div>
            </div>
          </div>
        )}

        {!isFuturePlan ? (
          <div className={MODAL_FIELD}>
            <span className={MODAL_LABEL}>Progress</span>
            <ProgressInline value={progress} readOnly />
          </div>
        ) : null}

        <div className={MODAL_FIELD}>
          <span className={MODAL_LABEL}>Notes</span>
          <div className={`${MODAL_READONLY} ${MODAL_NOTES_VIEW}`}>
            {hasNotes ? task.outcome : "No notes added."}
          </div>
        </div>
      </div>
    </TaskModalShell>
  );
}

export default TaskViewModal;
